import { supabase } from '../supabase/client';
import { v4 as uuidv4 } from 'uuid';
import { getApiUrl } from '../config';

// Session ID management
const SESSION_ID_KEY = 'pokket_chat_session_id';
const SESSION_TIMESTAMP_KEY = 'pokket_chat_session_timestamp';

// Debug flag
const DEBUG = true;

// For debugging
console.log('POKKETAPI BASE_URL:', process.env.REACT_APP_POKKETAPI_URL);

/**
 * Get the current chat session or create a new one if none exists
 * @returns {Promise<Object>} Session data including session ID
 */
export const getSession = async () => {
  try {
    const headers = await getBaseHeaders();
    const apiUrl = getApiUrl('/api/v1/chat/get-session');
    if (DEBUG) console.log('Getting session from API URL:', apiUrl);
    
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers
    });
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    const sessionData = await response.json();
    
    if (DEBUG) {
      console.log('Session data response:', sessionData);
    }
    
    // Store the session ID in localStorage
    if (sessionData && sessionData.sessionId) {
      localStorage.setItem(SESSION_ID_KEY, sessionData.sessionId);
      localStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());
    }
    
    return sessionData;
  } catch (error) {
    console.error('Error getting session:', error);
    throw error;
  }
};

/**
 * Generate a new session ID and store it in localStorage
 * @returns {string} The new session ID
 */
export const generateNewSessionId = () => {
  const sessionId = uuidv4();
  localStorage.setItem(SESSION_ID_KEY, sessionId);
  localStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());
  return sessionId;
};

/**
 * Get the current session ID from local storage
 * @returns {string} The current session ID
 */
export const getSessionId = () => {
  return localStorage.getItem(SESSION_ID_KEY);
};

/**
 * Update the session timestamp to extend the session
 */
export const updateSessionTimestamp = () => {
  localStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());
};

/**
 * Get the base headers for API requests including auth and session ID
 * @returns {Object} Headers object
 */
const getBaseHeaders = async () => {
  // Get the session token from Supabase
  const { data } = await supabase.auth.getSession();
  const accessToken = data?.session?.access_token;
  const sessionId = getSessionId();
  
  const headers = {
    'Authorization': `Bearer ${accessToken}`,
    'Content-Type': 'application/json'
  };
  
  // Only add session ID if it exists
  if (sessionId) {
    headers['X-Session-ID'] = sessionId;
  }
  
  return headers;
}; 